module.exports = __webpack_public_path__ + "static/mobile-bycaliber-d7cef007de4a2dc9587ea4b96126c556.png";